import { render, staticRenderFns } from "./write-msg.vue?vue&type=template&id=53fbe344&scoped=true&"
import script from "./write-msg.vue?vue&type=script&lang=js&"
export * from "./write-msg.vue?vue&type=script&lang=js&"
import style0 from "./write-msg.vue?vue&type=style&index=0&id=53fbe344&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53fbe344",
  null
  
)

export default component.exports